export default __webpack_public_path__ + "static/media/EFFS.e3ea519a.png";